import { injectGlobal, css } from 'styled-components'
import dotStick from '../assets/fonts/dot-stick-doodles.ttf'
import GTAmericaStandard from '../assets/fonts/GT-America-Standard-Regular.woff'
import GTAmericaBold from '../assets/fonts/GT-America-Standard-Bold.woff'
import GTAmericaExpandedBold from '../assets/fonts/GT-America-Expanded-Bold.woff'
import GTAmericaCondensedBold from '../assets/fonts/GT-America-Condensed-Bold.woff'
import GTSectraMedium from '../assets/fonts/GT-Sectra-Medium.woff'

injectGlobal`
    body {
        font-size: 14px;
        font-family: 'Helvetica', Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
    }

    @font-face {
        font-family: 'Dot Stick';
        src: url(${dotStick});
    }

    @font-face {
        font-family: 'GT America';
        font-weight: 300;
        src: url(${GTAmericaStandard});
    }

    @font-face {
        font-family: 'GT America';
        font-weight: 500;
        src: url(${GTAmericaBold});
    }

    @font-face {
        font-family: 'GT America Expanded Bold';
        font-weight: 500;
        src: url(${GTAmericaExpandedBold});
    }

    @font-face {
        font-family: 'GT America Condensed Bold';
        font-weight: 500;
        src: url(${GTAmericaCondensedBold});
    }

    @font-face {
        font-family: 'GT Sectra Medium';
        font-weight: 300;
        src: url(${GTSectraMedium});
    }
`

export const resolveHeaderType = (type) => {
    if (type == 'A') return css`	
        font-family: 'GT America Condensed Bold';
        font-weight: 500;
    `

    if (type == 'B') return css`
        font-family: 'GT America';
        font-weight: 300;
    `

    if (type == 'C') return css`
        font-family: 'GT America Expanded Bold';
        font-weight: 500;
    `

    if (type == 'D') return css`
        font-family: 'GT America';
        font-weight: 500;
    `

    if (type == 'E') return css`
        font-family: 'GT Sectra Medium';
        font-weight: 300;
    `   
}


// WEBPACK FOOTER //
// ./src/styles/fonts.js